import { render, staticRenderFns } from "./VerifyCurrentSession.vue?vue&type=template&id=4068965c&"
import script from "./VerifyCurrentSession.vue?vue&type=script&lang=ts&"
export * from "./VerifyCurrentSession.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports